<template>
  <AdminModal
    :is-open="open"
    :modal-title="`결제 내역 상세`"
    :close="modalClose"
    :confirm="confirm"
    :confirm-button-title="confirmButtonTitle"
    name="paymentDetailModal"
  >
    <div class="card">
      <div class="card-header">
        결제 정보
        <PaymentStatusBadge :payment-status="payment.status" :status-ko="payment.statusKo"/>
      </div>
      <ul class="card-body">
        <li>
          <label for="exampleFormControlInput1" class="form-label">결제자명</label>
          <p id="exampleFormControlInput1" class="text-right">{{payment.buyerName}}</p>
        </li>
        <li>
          <label for="exampleFormControlInput1" class="form-label">주문번호</label>
          <p id="exampleFormControlInput1" class="text-right cursor" v-on:click="copy(payment.paymentKey)">{{payment.paymentKey}}</p>
        </li>
        <li>
          <label for="exampleFormControlInput1" class="form-label">구매자명</label>
          <p id="exampleFormControlInput1" class="text-right">{{payment && payment.buyerName}}</p>
        </li>
        <li>
          <label for="exampleFormControlInput1" class="form-label">전화번호</label>
          <p id="exampleFormControlInput1" class="text-right">{{(payment && payment.phoneNumber) || "-"}}</p>
        </li>
        <li v-if="!!payment.lessonAccess">
          <label for="exampleFormControlInput1" class="form-label">학생코드</label>
          <p id="exampleFormControlInput1" class="text-right">{{payment && payment.lessonAccess}}</p>
        </li>
        <li v-if="payment.productType==='PAYMENT_LINK'">
          <label for="exampleFormControlInput1" class="form-label">구매 상품</label>
          <p id="exampleFormControlInput1" class="text-right">{{payment && payment.productTitle}}</p>
        </li>
        <li v-if="payment.productType === 'PRODUCT_LESSON' && !!payment.paymentProductLesson">
          <label for="exampleFormControlInput1" class="form-label">(필수) 수업</label>
          <p id="exampleFormControlInput1" class="text-right">{{payment && payment.paymentProductLesson.title}}</p>
        </li>
        <li v-if="payment.productType === 'PRODUCT_LESSON' && !!payment.paymentProductLesson">
          <label for="exampleFormControlInput1" class="form-label">(옵션) 수업</label>
          <p
            v-for="(productOption, index) in payment.paymentProductLesson.productOptions" :key="index"
            class="text-right"
          >
            {{`${productOption.title} - ${productOption.amount.toLocaleString()}원`}}
          </p>
        </li>
        <li v-if="payment.productType === 'PRODUCT_LESSON' && !!payment.paymentProductLesson">
          <label for="exampleFormControlInput1" class="form-label">할인 내용</label>
          <p
            v-for="(productDiscount, index) in payment.paymentProductLesson.productDiscounts" :key="index"
            class="text-right"
          >
            {{`${productDiscount.title} - ${productDiscount.discountAmount.toLocaleString()}원`}}
          </p>
        </li>
        <li v-if="payment.productType === 'PRODUCT_LESSON' && !!payment.paymentProductLesson">
          <label for="exampleFormControlInput1" class="form-label">요청사항</label>
          <p id="exampleFormControlInput1" class="text-right">{{payment && payment.paymentProductLesson.memo}}</p>
        </li>
        <li>
          <label for="exampleFormControlInput1" class="form-label">결제 가격</label>
          <p id="exampleFormControlInput1" class="text-right">{{(payment && payment.amount.toLocaleString('ko-KR')) || 0}}원</p>
        </li>
        <li v-if="payment.paymentTypeKo">
          <label class="form-label">결제 수단</label>
          <p class="text-right">{{ payment.paymentTypeKo }}</p>
        </li>
        <li>
          <label for="exampleFormControlInput1" class="form-label">결제 일시</label>
          <p id="exampleFormControlInput1" class="text-right">{{ payment.paidAt ? getDate(payment.paidAt) : '-' }}</p>
        </li>
        <li v-if="payment.productType==='PAYMENT_LINK'">
          <label for="exampleFormControlInput1" class="form-label">결제 링크</label>
          <p id="exampleFormControlInput1" class="text-right cursor" v-on:click="copyLink(payment.paymentLinkKey)">{{`kessam.com/pay/${payment.paymentLinkKey}`}}</p>
        </li>
        <li>
          <label for="exampleFormControlInput1" class="form-label">결제 생성 일시</label>
          <p id="exampleFormControlInput1" class="text-right">{{payment && getDate(payment.createdAt)}}</p>
        </li>
      </ul>
    </div>
    <div v-if="payment.paymentType === 'vbank' && hasVactInfo" class="card mt-3">
      <div class="card-header">가상계좌 (무통장 입금)</div>
      <ul class="card-body">
        <li v-if="payment.vactBankName">
          <label class="form-label">은행</label>
          <p class="text-right">{{ payment.vactBankName }} <span v-if="payment.vactBankCode" class="text-muted">({{ payment.vactBankCode }})</span></p>
        </li>
        <li v-if="payment.vactNum">
          <label class="form-label">가상계좌 번호</label>
          <p class="text-right cursor" v-on:click="copy(payment.vactNum)">{{ payment.vactNum }}</p>
        </li>
        <li v-if="payment.vactName">
          <label class="form-label">예금주</label>
          <p class="text-right">{{ payment.vactName }}</p>
        </li>
        <li v-if="payment.vactInputName">
          <label class="form-label">입금자명</label>
          <p class="text-right">{{ payment.vactInputName }}</p>
        </li>
        <li v-if="payment.vactDate || payment.vactTime">
          <label class="form-label">입금 마감</label>
          <p class="text-right">{{ formatVactDeadline(payment.vactDate, payment.vactTime) }}</p>
        </li>
      </ul>
    </div>
    <div v-if="payment.cardName !== '' && payment.cardName !== null" class="card mt-3">
      <div class="card-header">카드 정보</div>
      <div class="card-body">
        <label for="exampleFormControlInput1" class="form-label">카드 이름</label>
        <p id="exampleFormControlInput1" class="text-right">{{payment.cardName}}</p>
        <label for="exampleFormControlInput1" class="form-label">영수증</label>
        <a v-if="payment.cardReceipt" id="exampleFormControlInput1" class="text-right float-end cursor" :href="payment.cardReceipt" target='_blank'>영수증 보기</a>
        <p v-else class="text-right">-</p>
      </div>
    </div>
    <div v-if="payment.paymentRefunds && payment.paymentRefunds.length > 0" class="card mt-3">
      <div class="card-header">환불 정보</div>
      <div class="card-body" v-for="(paymentRefund, index) in payment.paymentRefunds" :key="index">
        <label for="exampleFormControlInput1" class="form-label">환불 금액</label>
        <p id="exampleFormControlInput1" class="text-right text-danger">-{{paymentRefund.amount.toLocaleString('ko-KR')}}원</p>
        <template v-if="paymentRefund.refundBankCode || paymentRefund.refundBankName || paymentRefund.refundAcctNum || paymentRefund.refundAcctName">
          <label class="form-label">환불 은행</label>
          <p class="text-right">{{ paymentRefund.refundBankName || '-' }}<span v-if="paymentRefund.refundBankCode"> ({{ paymentRefund.refundBankCode }})</span></p>
          <label class="form-label">환불 계좌번호</label>
          <p class="text-right">{{ paymentRefund.refundAcctNum || '-' }}</p>
          <label class="form-label">환불 예금주</label>
          <p class="text-right">{{ paymentRefund.refundAcctName || '-' }}</p>
        </template>
        <label for="exampleFormControlInput3" class="form-label">환불일</label>
        <p id="exampleFormControlInput3" class="text-right">{{getDate(paymentRefund.createdAt)}}</p>
        <label for="exampleFormControlInput2" class="form-label">취소 영수증</label>
        <a v-if="paymentRefund.receipt" id="exampleFormControlInput2" class="text-right float-end cursor" :href="paymentRefund.receipt" target='_blank'>영수증 보기</a>
        <p v-else class="text-right">-</p>
      </div>
    </div>
  </AdminModal>
</template>

<script>
import AdminModal from "@/components/modals/AdminModal.vue";
import api from "@/api/api";
import customDate from "@/util/custom-date";
import PaymentStatusBadge from "@/components/PaymentStatusBadge";
import {copyText} from "vue3-clipboard";

export default {
  components: {PaymentStatusBadge, AdminModal},
  name: "PaymentDetailModal",
  props: ["id","modalTitle", "modalClose","confirmButtonTitle","open","confirm"],
  computed: {
    hasVactInfo() {
      const p = this.payment
      return !!(p.vactNum || p.vactBankName || p.vactDate)
    },
  },
  data(){
    return {
      toastText: "",
      showToast: false,
      payment: {
        amount: 0,
        buyerName: "",
        cardName: "",
        cardReceipt: "",
        createdAt: "",
        paidAt: "",
        paymentKey: "",
        paymentLinkId: 0,
        paymentLinkKey: "",
        paymentType: "card",
        productAmount: 0,
        productId: 0,
        productTitle: "",
        refundedAt: null,
        status: "",
        statusKo: "",
        lessonAccess: "",
        paymentProductLesson: null,
        productType: "PAYMENT_LINK",
        paymentTypeKo: "",
        vactBankCode: "",
        vactBankName: "",
        vactNum: "",
        vactName: "",
        vactInputName: "",
        vactDate: "",
        vactTime: "",
      }
    }
  },
  mounted() {
    console.log(this.id)
    this.detail()
  },
  methods: {
    getDate(date){
      return customDate.stringFormat(date)
    },
    formatVactDeadline(dateStr, timeStr) {
      if (!dateStr) return '-'
      const ds = String(dateStr).replace(/\D/g, '')
      let out = ds.length === 8 ? `${ds.slice(0, 4)}-${ds.slice(4, 6)}-${ds.slice(6, 8)}` : dateStr
      const ts = timeStr ? String(timeStr).replace(/\D/g, '') : ''
      if (ts.length >= 6) {
        out += ` ${ts.slice(0, 2)}:${ts.slice(2, 4)}:${ts.slice(4, 6)}`
      }
      return out
    },
    getStatusBadge(status) {
      if (status === "waiting") return "-secondary"
      else if(status === "complete") return "-success"
      else if(status === "refund") return "-danger"
      else return "-warning"
    },
    getStatus(status){
      if (status === "waiting") return "대기중"
      else if(status === "complete") return "결제완료"
      else if(status === "refund") return "환불"
      else if(status === "canceled") return "취소"
      else return "실패"
    },
    copyLink(linkKey){
      const url = `${process.env.VUE_APP_WEB_URL}/pay/${linkKey}`
      this.copy(url)
    },
    copy(text){
      copyText(text, undefined, (err, event) => {
        this.$toast.show(err ? '복사 할 수 없습니다.' : '복사 완료',
          {
            position: "top-right",
            duration: 2000
          });
      })
    },
    detail(){
      api.payment.detail({id: this.id}, (response) => {
        this.payment = response.data
      }, (error) => {
        console.log(error.message)
      })
    }
  }
}
</script>

<style scoped>
.text-right{
  text-align: right;
}
</style>